import styled from 'styled-components';

export const StyledOutletFooter = styled.div`
  flex-shrink: 0;
  display: flex;
  gap: ${({ theme }): string => theme.spacing_unit_x1};
  border-top-style: solid;
  border-top-width: 1px;
  border-top-color: ${({ theme }): string => theme.palette_gray_10};
  box-sizing: border-box;
  width: 100%;
  padding: ${({ theme }): string => theme.spacing_unit_x2};

  & > a,
  & > button {
    flex: 1;
    text-align: center;
    justify-content: center;
    max-width: 300px;
    margin: 0 auto;
  }
`;
